// extracted by mini-css-extract-plugin
var _1 = "BirdviewCardBody-modulebody__ubr2e";
export { _1 as "body" }
